import { useMemo } from "react";

import { useQueryHook } from "hooks";
import { useDealActions, useTaggerDealIdSelector, useTaggerDocumentSelector } from "store";
import { DealBase, TaggerDocument } from "store/types";

const useDeals = (docId?: TaggerDocument["id"]) => {
  const document = useTaggerDocumentSelector(docId || 0) || null;

  const { getDealsBaseAction } = useDealActions();
  const { loading, data: deals = [] } = useQueryHook<DealBase[]>(getDealsBaseAction);

  const dealOptions = useMemo(
    () =>
      (deals || []).map(({ id, title }) => ({
        label: title,
        value: id
      })),
    [deals]
  );

  const selectedDeal = useTaggerDealIdSelector();

  return {
    options: dealOptions,
    value: document?.dealId || selectedDeal,
    loading,
    onChange: () => {} // unused
  };
};

export default useDeals;
